document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-tw-sticky-atc]').forEach(function (bar) {
    var trigger = bar.querySelector('[data-tw-sticky-atc-trigger]');
    var label = bar.querySelector('[data-tw-sticky-atc-label]');
    if (!trigger) return;

    var target = document.getElementById(trigger.getAttribute('data-target'));
    if (!target) return;

    trigger.addEventListener('click', function () {
      target.click();
    });

    var sync = function () {
      trigger.disabled = target.disabled;
      if (label) label.textContent = target.textContent.trim();
    };

    sync();
    new MutationObserver(sync).observe(target, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            bar.classList.toggle('is-visible', scrolledPast);
          });
        },
        { threshold: 0 }
      );
      observer.observe(target);
    }
  });
});
